const DownArrowSvg = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4898 4.10156H2.51011C2.24077 4.10156 2.09038 4.38594 2.25718 4.58008L6.74702 9.78633C6.87554 9.93535 7.123 9.93535 7.25288 9.78633L11.7427 4.58008C11.9095 4.38594 11.7591 4.10156 11.4898 4.10156Z"
        fill="#67717A"
        fillOpacity="0.4"
      ></path>
    </svg>
  );
};

export default DownArrowSvg;
